import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Button,
  CardContent,
  Container,
  Typography,
  Paper,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Autocomplete,
  Checkbox,
  Modal,
  useTheme,
  useMediaQuery,
  Dialog,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import ResponsiveDialog from "../../component/dialog/dialog";
import panelService from "../../service/servicePanel";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import customerService from "../../service/serviceCustomer";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import ImageComp from "../../component/image-comp/image";
import { getErrorMessage } from "../../service/api";

function NewPanel() {
  // Função de filtro customizada que limita os resultados para melhor performance
  const filterCustomerOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    
    // Filtrar e limitar a 300 resultados
    const filtered = options.filter((option) => {
      const searchString = `${option.name} ${option.cpfCnpj || ''}`.toLowerCase();
      return searchString.includes(inputValueLower);
    });
    
    return filtered.slice(0, 300);
  };

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState("");

  const [user, setUser] = useState("");

  const [idAddress, setIdAddress] = useState();

  const [cep, setCep] = useState("");
  const [cepError, setCepError] = useState("");

  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState("");

  const [number, setNumber] = useState();
  const [numberError, setNumberError] = useState();

  const [neighborhood, setNeighborhood] = useState("");
  const [neighborhoodError, setNeighborhoodError] = useState("");

  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");

  const [complement, setComplement] = useState("");

  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");

  const [country, setCountry] = useState("Brasil");
  const [countryError, setCountryError] = useState("");

  const [qtdInsercao, setQtdInsercao] = useState("");
  const [qtdInsercaoError, setQtdInsercaoError] = useState("");

  const [isActive, setIsActive] = useState(false);

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();

  const [listaIDCustomer, setListaIDCustomer] = useState([]);
  const [listCustomer, setListCustomer] = useState([]);

  const [idCustomer, setIdCustomer] = useState();
  const [idCustomerError, setIdCustomerError] = useState("");

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitudeError, setLatitudeError] = useState("");
  const [longitudeError, setLongitudeError] = useState("");
  const [open, setOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const [image, setImage] = useState();

  const [listFormatPanel, setListFormatPanel] = useState([
    {
      id: 1,
      nome: "23x43",
    },
  ]);
  const [idFormat, setIdFormat] = useState(0);
  const [formatError, setFormatError] = useState("");

  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&output=embed`;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const { id } = useParams();

  let navigate = useNavigate();

  const usuario = JSON.parse(localStorage.getItem("user_token")) || {};
  const permission = usuario.roles?.filter((item) => item.name == "Painel")[0];

  useEffect(() => {
    (async () => {
      if (id) {
        const response = await panelService.edit(id);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          const item = response.data;

          setName(item?.name);
          setType(item?.type);
          setQtdInsercao(item?.qtdInsercao);
          setUser(item?.user);
          setIsActive(item?.isActive);
          setImagePreview(item?.imageBase64);
          setIdAddress(item?.address?.idAddress);
          setAddress(item?.address?.address);
          setNumber(item?.address?.number);
          setNeighborhood(item?.address?.neighborhood);
          setCity(item?.address?.city);
          setComplement(item?.address?.complement);
          setState(item?.address?.state);
          setCountry(item?.address?.country);
          setCep(item?.address?.cep);
          setLatitude(item?.latitude ? item?.latitude : "");
          setLongitude(item?.longitude ? item?.longitude : "");
          setIdFormat(item?.idFormat);
          setType(item?.type);
          setQtdInsercao(item?.qtdInsercao);
          setUser(item?.user);
          setIsActive(item?.isActive);
          setImagePreview(item?.imageBase64);
          setIdAddress(item?.address?.idAddress);
          setAddress(item?.address?.address);
          setNumber(item?.address?.number);
          setNeighborhood(item?.address?.neighborhood);
          setCity(item?.address?.city);
          setComplement(item?.address?.complement);
          setState(item?.address?.state);
          setCountry(item?.address?.country);
          setCep(item?.address?.cep);
          setLatitude(item?.latitude ? item?.latitude : "");
          setLongitude(item?.longitude ? item?.longitude : "");
          setIdFormat(item?.idFormat);

          if (item?.idCustomer) {
            setIdCustomer(item?.idCustomer);
          }
        } else {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(
            getErrorMessage(response) || "Erro ao buscar painel"
          );
        }
      }
    })();

    var listCust = [];
    customerService
      .listCustomerLocatario(1, 10000)
      .then((item) => {
        item.data.forEach((element) => {
          listCust.push(element);
        });

        setListCustomer(listCust);
      })
      .catch((error) => {
        console.log(error);
      });

    var listFormat = [];
    panelService
      .listFormat()
      .then((item) => {
        item.forEach((element) => {
          listFormat.push(element);
        });

        setListFormatPanel(listFormat);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  // useEffect para definir o cliente selecionado quando a lista de clientes e idCustomer estiverem disponíveis
  useEffect(() => {
    if (idCustomer && listCustomer.length > 0) {
      const customerFound = listCustomer.find(
        (customer) => customer.idcustomer === idCustomer
      );
      if (customerFound) {
        // Verifica se o cliente já está definido corretamente para evitar atualizações desnecessárias
        if (!listaIDCustomer || listaIDCustomer.idcustomer !== idCustomer) {
          setListaIDCustomer(customerFound);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCustomer, listCustomer]);

  async function save() {
    try {
      if (valid()) {
        var addressData = {
          idAddress: idAddress,
          cep: cep,
          address: address,
          number: number,
          neighborhood: neighborhood,
          city: city,
          complement: complement,
          state: state,
          country: country,
        };

        const formData = new FormData();

        formData.append("idpanel", id);
        formData.append("name", name);
        formData.append("qtdInsercao", qtdInsercao);
        formData.append("type", type);
        formData.append("idCustomer", idCustomer);
        formData.append("isActive", isActive);
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("idFormat", idFormat);
        formData.append("address", JSON.stringify(addressData));
        if (image instanceof File) {
          formData.append("image", image); // mesmo nome usado no multer: upload.single('image')
        } else {
          console.warn("Nenhuma imagem selecionada ou tipo inválido");
        }

        console.log(formData);

        const response = await panelService.save(formData);

        if (response.success) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog("Painel cadastrado com sucesso!");
        } else {
          handleDialogOpen();
          setTitleDialog("Ops");
          setMessageDialog(response.message);
        }
      }
    } catch (error) {
      handleDialogOpen();
      setTitleDialog("Ops");
      setMessageDialog(getErrorMessage(error));
    }
  }

  //Função para consultar CEP
  async function buscarCep(input) {
    if (input.length < 8) {
      return;
    } else {
      try {
        const response = await fetch(
          "https://brasilapi.com.br/api/cep/v2/" + input,
          { mode: "cors" }
        );

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          const data = await response.json();

          if (data.hasOwnProperty("erro") || data?.type == "service_error") {
            setCepError(
              "O " + cep + " não foi encontrado em nenhum serviço de consulta"
            );
            setAddress("");
            setCity("");
            setNeighborhood("");
            setNumber("");
            setState("");
          } else if (data) {
            setCepError("");
            setAddress(data.street);
            setCity(data.city);
            setNeighborhood(data.neighborhood);
            setState(data.state);
          }
        }
      } catch (error) {
        console.log(error);
        setCepError(getErrorMessage(error) || "Erro ao buscar CEP");
      }
    }
  }

  async function update() {
    try {
      if (valid()) {
        const addressData = {
          idAddress: idAddress,
          cep: cep,
          address: address,
          number: number,
          neighborhood: neighborhood,
          city: city,
          complement: complement,
          state: state,
          country: country,
        };

        const formData = new FormData();

        formData.append("idpanel", id);
        formData.append("name", name);
        formData.append("qtdInsercao", qtdInsercao);
        formData.append("type", type);
        formData.append("idCustomer", idCustomer);
        formData.append("isActive", isActive);
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("idFormat", idFormat);
        formData.append("address", JSON.stringify(addressData));
        if (image instanceof File) {
          formData.append("image", image); // mesmo nome usado no multer: upload.single('image')
        } else {
          console.warn("Nenhuma imagem selecionada ou tipo inválido");
        }

        const response = await panelService.update(formData);

        if (response.success) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog("Painel atualizado com sucesso");
        } else {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message);
        }
      }
    } catch (error) {
      handleDialogOpen();
      setTitleDialog("Ops");
      setMessageDialog(getErrorMessage(error));
    }
  }

  function valid() {
    let thatsOk = true;

    if (!name) {
      setNameError("O nome precisa ser preenchido");
      thatsOk = false;
    }
    if (!type) {
      setTypeError("O tipo precisa ser preenchido");
      thatsOk = false;
    }
    if (!qtdInsercao) {
      setQtdInsercaoError("A quantidade precisa ser preenchida");
      thatsOk = false;
    }
    if (!cep) {
      setCepError("O cep precisa ser preenchido");
      thatsOk = false;
    }
    if (!address) {
      setAddressError("O Endereço precisa ser preenchido");
      thatsOk = false;
    }
    if (!number) {
      setNumberError("O Número precisa ser preenchido");
      thatsOk = false;
    }
    if (!neighborhood) {
      setNeighborhoodError("O Bairro precisa ser preenchido");
      thatsOk = false;
    }
    if (!city) {
      setCityError("A cidade precisa ser preenchida");
      thatsOk = false;
    }
    if (!state) {
      setStateError("O Estado precisa ser preenchido");
      thatsOk = false;
    }
    if (!country) {
      setCountryError("O Pais precisa ser preenchido");
      thatsOk = false;
    }

    console.log(idCustomer);

    if (!idFormat) {
      setFormatError("O Formato precisa ser preenchido");
      thatsOk = false;
    }
    if (!latitude) {
      setLatitudeError("A Latitude precisa ser preenchida");
      thatsOk = false;
    }
    if (!longitude) {
      setLongitudeError("A Longitude precisa ser preenchida");
      thatsOk = false;
    }
    if (!idCustomer) {
      setIdCustomerError("O cliente precisa ser preenchida");
      thatsOk = false;
    }

    return thatsOk;
  }

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/listPanel");
  };

  const cancel = () => {
    navigate("/listPanel");
  };

  const handleChangeClient = (input, newInput) => {
    setIdCustomer(input?.idcustomer);
    setListaIDCustomer(input);
  };

  const handleCheckd = (value) => {
    setIsActive(value);
  };

  const closeOpen = () => {
    setOpen(false);
  };

  const handleChangeFormat = (input) => {
    setIdFormat(input.target.value);
    setFormatError("");
  };

  const handleChange = (event) => {
    const file = event.target.files?.[0];

    if (file && ["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setImage(file);
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    } else {
      setImage(null);
      setImagePreview(null);
    }
  };

  return (
    <>
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
        <DrawerPrincipal
          divOpen={
            <div>
              <div>
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Lista de Painéis"}
                    link2={"#"}
                    title3={"Cadastro de Painel"}
                    link3={"#"}
                  />
                </div>
                <ResponsiveDialog
                  open={openDialog}
                  handleClose={handleDialogClose}
                  title={titleDialog}
                  message={messageDialog}
                  status={statusDialog}
                />

                <div className="row">
                  <h1 className="h3 mb-3 text-black font-weight-bold">
                    {" "}
                    Cadastro de Painel{" "}
                  </h1>
                </div>

                <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div style={{ padding: 5 }}></div>
                        <Card>
                          <div
                            className="form-cadastro"
                            style={{ padding: 20 }}
                          >
                            <Typography
                              sx={{ width: 14 }}
                              className="mb-3"
                              gutterBottom
                              variant="h7"
                              component="div"
                            >
                              Painel
                            </Typography>

                            <div className="row">
                              <div className="col-md-8 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  label={
                                    name ? "Nome do painel" : "Nome do painel"
                                  }
                                  id="outlined-size-small"
                                  focused={name && name}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  size="small"
                                  value={name && name}
                                  onChange={(e) => {
                                    setName(e.target.value);
                                    setNameError("");
                                  }}
                                  error={nameError && nameError}
                                  helperText={nameError ? nameError : ""}
                                />
                              </div>

                              <div className="col-md-2 mb-3">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={typeError && typeError}
                                >
                                  <InputLabel id="demo-select-small">
                                    Tipo
                                  </InputLabel>
                                  <Select
                                    labelId="demo-select-small"
                                    id="demo-select-small"
                                    value={type && type}
                                    disabled={
                                      !permission?.isinsert ? true : false
                                    }
                                    focused={type && type}
                                    label="Tipo"
                                    onChange={(e) => {
                                      setType(e.target.value);
                                      setTypeError("");
                                    }}
                                    helperText={typeError ? typeError : ""}
                                  >
                                    <MenuItem value={"Horizontal"}>
                                      Horizontal
                                    </MenuItem>
                                    <MenuItem value={"Vertical"}>
                                      Vertical
                                    </MenuItem>
                                    <MenuItem value={"Indoor"}>Indoor</MenuItem>
                                    <MenuItem value={"Relógio"}>Relógio</MenuItem>
                                  </Select>
                                  <FormHelperText>
                                    {typeError ? typeError : ""}
                                  </FormHelperText>
                                </FormControl>
                              </div>
                              <div className="col-md-2">
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        disabled={
                                          !permission?.isinsert ? true : false
                                        }
                                        checked={isActive && isActive}
                                        onClick={(e) =>
                                          handleCheckd(e.target.checked)
                                        }
                                      />
                                    }
                                    label="Ativo"
                                  />
                                </FormGroup>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-3">
                                <TextField
                                  fullWidth
                                  required
                                  label={
                                    qtdInsercao
                                      ? "Qtd de inserção"
                                      : "Qtd de inserção"
                                  }
                                  id="outlined-size-small"
                                  type="number"
                                  focused={qtdInsercao && qtdInsercao}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  size="small"
                                  value={qtdInsercao && qtdInsercao}
                                  onChange={(e) => {
                                    setQtdInsercao(e.target.value);
                                    setQtdInsercaoError("");
                                  }}
                                  error={qtdInsercaoError && qtdInsercaoError}
                                  helperText={
                                    qtdInsercaoError ? qtdInsercaoError : ""
                                  }
                                />
                              </div>

                              <div className="col-md-3 mb-3">
                                <Autocomplete
                                  size="small"
                                  id="combo-box-demo1"
                                  value={listaIDCustomer && listaIDCustomer}
                                  sx={{ width: "100%" }}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  getOptionLabel={(listCustomer) => {
                                    if (listCustomer.idcustomer) {
                                      return `${listCustomer.name} (${listCustomer.idcustomer})`;
                                    } else {
                                      return "Escolha o cliente";
                                    }
                                  }}
                                  options={listCustomer}
                                  filterOptions={filterCustomerOptions}
                                  isOptionEqualToValue={(option, value) =>
                                    option.idcustomer === value.idcustomer
                                  }
                                  onChange={(event, newValue) => {
                                    handleChangeClient(newValue);
                                    setIdCustomerError("");
                                  }}
                                  noOptionsText={
                                    "Nenhum Cliente com esse nome foi encontrando"
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      required
                                      label="Escolher cliente"
                                      error={!idCustomer ? idCustomerError : ""}
                                      disabled={
                                        !permission?.isinsert ? true : false
                                      }
                                      helperText={
                                        !idCustomer ? idCustomerError : ""
                                      }
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-md-2">
                                <TextField
                                  fullWidth
                                  required
                                  label={latitude ? "Latitude" : "Latitude"}
                                  id="outlined-size-small"
                                  focused={latitude && latitude}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  size="small"
                                  value={latitude && latitude}
                                  onChange={(e) => {
                                    setLatitude(e.target.value);
                                    setLatitudeError("");
                                  }}
                                  error={latitudeError && latitudeError}
                                  helperText={
                                    latitudeError ? latitudeError : ""
                                  }
                                />
                              </div>
                              <div className="col-md-2">
                                <TextField
                                  fullWidth
                                  required
                                  label={longitude ? "Longitude" : "Longitude"}
                                  id="outlined-size-small"
                                  focused={longitude && longitude}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  size="small"
                                  value={longitude && longitude}
                                  onChange={(e) => {
                                    setLongitude(e.target.value);
                                    setLongitudeError("");
                                  }}
                                  error={longitudeError && longitudeError}
                                  helperText={
                                    longitudeError ? longitudeError : ""
                                  }
                                />
                              </div>
                              <div className="col-md-2">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={Boolean(formatError)}
                                >
                                  <InputLabel id="tipo-servico-label">
                                    Formato
                                  </InputLabel>
                                  <Select
                                    labelId="tipo-servico-label"
                                    id="tipo-servico-select"
                                    value={idFormat}
                                    disabled={!permission?.isinsert}
                                    label="Formato do Painel"
                                    onChange={handleChangeFormat}
                                  >
                                    {listFormatPanel.map((item) => (
                                      <MenuItem
                                        key={item.idFormat}
                                        value={item.idFormat}
                                      >
                                        {item.describe}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <FormHelperText style={{ color: "red" }}>
                                    {formatError || ""}
                                  </FormHelperText>
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        </Card>

                        <div style={{ padding: 5 }}></div>
                        <Card>
                          <CardContent>
                            <Typography
                              sx={{ width: 14 }}
                              className="mb-3"
                              gutterBottom
                              variant="h7"
                              component="div"
                            >
                              Endereço
                            </Typography>
                            <div className="row">
                              <div className="col-md-3 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  focused={cep && cep}
                                  label="Cep "
                                  id="outlined-size-small"
                                  size="small"
                                  maxLength="8"
                                  value={cep && cep}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  onChange={(e) => {
                                    setCep(e.target.value);
                                    buscarCep(e.target.value);
                                    setCepError("");
                                  }}
                                  inputProps={{ maxLength: 8 }}
                                  error={cepError && cepError}
                                  helperText={cepError ? cepError : ""}
                                />
                              </div>
                              <div className="col-md-3 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  focused={address && address}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  label="Endereço "
                                  id="outlined-size-small"
                                  size="small"
                                  value={address && address}
                                  onChange={(e) => {
                                    setAddress(e.target.value);
                                    setAddressError("");
                                  }}
                                  error={addressError && addressError}
                                  helperText={addressError ? addressError : ""}
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  focused={number && number}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  label="Número"
                                  id="outlined-size-small"
                                  size="small"
                                  value={number && number}
                                  onChange={(e) => {
                                    setNumber(e.target.value);
                                    setNumberError("");
                                  }}
                                  error={numberError && numberError}
                                  helperText={numberError ? numberError : ""}
                                />
                              </div>
                              <div className="col-md-4 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  focused={neighborhood && neighborhood}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  label="Bairro"
                                  id="outlined-size-small"
                                  size="small"
                                  value={neighborhood && neighborhood}
                                  onChange={(e) => {
                                    setNeighborhood(e.target.value);
                                    setNeighborhoodError("");
                                  }}
                                  error={neighborhoodError && neighborhoodError}
                                  helperText={
                                    neighborhoodError ? neighborhoodError : ""
                                  }
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-3 mb-3">
                                <TextField
                                  fullWidth
                                  focused={complement && complement}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  label="Complemento "
                                  id="outlined-size-small"
                                  size="small"
                                  value={complement && complement}
                                  onChange={(e) => {
                                    setComplement(e.target.value);
                                  }}
                                />
                              </div>

                              <div className="col-md-4 mb-3">
                                <TextField
                                  fullWidth
                                  required
                                  focused={city && city}
                                  disabled={
                                    !permission?.isinsert ? true : false
                                  }
                                  label="Cidade"
                                  id="outlined-size-small"
                                  size="small"
                                  value={city && city}
                                  onChange={(e) => {
                                    setCity(e.target.value);
                                    setCityError("");
                                  }}
                                  error={cityError && cityError}
                                  helperText={cityError ? cityError : ""}
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={stateError && stateError}
                                >
                                  <InputLabel id="demo-select-small">
                                    Estado
                                  </InputLabel>
                                  <Select
                                    labelId="demo-select-small"
                                    id="demo-select-small"
                                    disabled={
                                      !permission?.isinsert ? true : false
                                    }
                                    focusede={state && state}
                                    value={state && state}
                                    label="Estado"
                                    onChange={(e) => {
                                      setState(e.target.value);
                                      setStateError("");
                                    }}
                                  >
                                    <MenuItem value={"AC"}>AC</MenuItem>
                                    <MenuItem value={"AL"}>AL</MenuItem>
                                    <MenuItem value={"AP"}>AP</MenuItem>
                                    <MenuItem value={"AM"}>AM</MenuItem>
                                    <MenuItem value={"BA"}>BA</MenuItem>
                                    <MenuItem value={"CE"}>CE</MenuItem>
                                    <MenuItem value={"GO"}>GO</MenuItem>
                                    <MenuItem value={"MA"}>MA</MenuItem>
                                    <MenuItem value={"MT"}>MT</MenuItem>
                                    <MenuItem value={"MS"}>MS</MenuItem>
                                    <MenuItem value={"MG"}>MG</MenuItem>
                                    <MenuItem value={"PA"}>PA</MenuItem>
                                    <MenuItem value={"PB"}>PB</MenuItem>
                                    <MenuItem value={"PR"}>PR</MenuItem>
                                    <MenuItem value={"PE"}>PE</MenuItem>
                                    <MenuItem value={"PI"}>PI</MenuItem>
                                    <MenuItem value={"RJ"}>RJ</MenuItem>
                                    <MenuItem value={"RN"}>RN</MenuItem>
                                    <MenuItem value={"RS"}>RS</MenuItem>
                                    <MenuItem value={"RO"}>RO</MenuItem>
                                    <MenuItem value={"RR"}>RR</MenuItem>
                                    <MenuItem value={"SC"}>SC</MenuItem>
                                    <MenuItem value={"SP"}>SP</MenuItem>
                                    <MenuItem value={"SE"}>SE</MenuItem>
                                    <MenuItem value={"TO"}>TO</MenuItem>
                                    <MenuItem value={"DF"}>DF</MenuItem>
                                  </Select>
                                  <FormHelperText>
                                    {stateError ? stateError : ""}
                                  </FormHelperText>
                                </FormControl>
                              </div>

                              <div className="col-md-2 mb-3">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={countryError && countryError}
                                >
                                  <InputLabel id="demo-select-small">
                                    Pais
                                  </InputLabel>
                                  <Select
                                    labelId="demo-select-small"
                                    id="demo-select-small"
                                    focused={country && country}
                                    disabled={
                                      !permission?.isinsert ? true : false
                                    }
                                    value={country && country}
                                    label="Pais"
                                    onChange={(e) => {
                                      setCountry(e.target.value);
                                      setCountryError("");
                                    }}
                                  >
                                    <MenuItem value={"Brasil"}>Brasil</MenuItem>
                                  </Select>
                                  <FormHelperText>
                                    {countryError ? countryError : ""}
                                  </FormHelperText>
                                </FormControl>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                        <div style={{ padding: 5 }}></div>
                        <Card>
                          <div className="row">
                            <div className="col d-flex align-items-start">
                              <div style={{ padding: 20 }}>
                                {/* Botão (label) para escolher imagem */}
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <label
                                    htmlFor="upload-image"
                                    style={{
                                      // backgroundColor: '#1976d2', // azul primário
                                      color: "#000",
                                      // padding: '10px 20px',
                                      borderRadius: 6,
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                      display: "inline-block",
                                    }}
                                  >
                                    Selecionar painel
                                  </label>

                                  <input
                                    id="upload-image"
                                    type="file"
                                    // value={imagePreview && imagePreview}
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleChange}
                                    style={{ display: "none" }}
                                  />
                                </div>

                                {/* Preview da imagem, se houver */}
                                {imagePreview && (
                                  <div className="row">
                                    <ImageComp
                                      width={150}
                                      height={120}
                                      url={imagePreview}
                                    />
                                    {/* <img
                                                                src={imagePreview}
                                                                alt="Preview"
                                                                style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }}
                                                            /> */}
                                  </div>
                                )}
                              </div>

                              {/* <div className="me-2" style={{padding: '10px'}}>

                                                                    {imagePreview && (
                                                                        <div style={{ marginTop: 16 }}>
                                                                        <ImageComp width={150} height={120} url={imagePreview}/>
                                                                        </div>
                                                                    )}

                                                                </div> */}
                              {/* <div >
                                                                <div  className="row" style={{ color: '#fff', padding: 20 }} >
                                                                    <label htmlFor="upload-image" style={{

                                                                        // backgroundColor: '#000', // primary color
                                                                        color: '#000',
                                                                        // padding: '10px 20px',
                                                                        borderRadius: 6,
                                                                        cursor: 'pointer',
                                                                        display: 'inline-block',
                                                                        // fontWeight: 'bold'
                                                                    }}>
                                                                        Selecionar painel
                                                                    </label>
                                                                </div>
                                                                <div  className="row" style={{ color: '#fff', padding: 20 }}>
                                                                    <div>
                                                                        <input
                                                                            id="upload-image"
                                                                            type="file"
                                                                            accept="image/png, image/jpeg, image/jpg"
                                                                            onChange={handleChange}
                                                                            style={{ display: 'none' }}
                                                                        />
                                                                    </div>
                                                                    
                                                                </div>

                                                            </div> */}
                            </div>
                            <div className="col d-flex align-items-start">
                              <div className="me-2" style={{ padding: "10px" }}>
                                {/* <TextField
                                                                    fullWidth                                                            
                                                                    label={image ? "Url da imagem" : "Url da imagem"}
                                                                    id="outlined-size-small"
                                                                    focused={image && image}
                                                                    disabled={!permission?.isinsert ? true : false}
                                                                    size="small"
                                                                    value={image && image}
                                                                    onChange={(e)=> {
                                                                        setUrlImage(e.target.value);
                                                                        // setNameError("")
                                                                    }}
                                                                    // error={nameError && nameError}
                                                                    // helperText={nameError ? nameError : ""}
                                                                /> */}
                              </div>
                              <div>
                                <h4>{name}</h4>
                                <Button
                                  type="primary"
                                  onClick={() => setOpen(true)}
                                >
                                  Ver no Mapa
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>{" "}
                      {/** Fecha segundo lado */}
                      <div className="row" style={{ padding: 50 }}>
                        <div className="col-md-8"></div>
                        <div className="col-md-2">
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={cancel}
                            sx={{ mr: 1 }}
                          >
                            <HighlightOffIcon />
                            {"Cancelar"}
                          </Button>
                        </div>
                        <div className="col-md-2">
                          {permission.isinsert ? (
                            <Button
                              variant="contained"
                              onClick={id ? update : save}
                              sx={{ mr: 1 }}
                            >
                              <AddIcon /> {"Salvar"}
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Paper>

                <Dialog
                  maxWidth={"sm"}
                  fullWidth={true}
                  fullScreen={fullScreen}
                  open={open}
                  onClose={closeOpen}
                  aria-labelledby="responsive-dialog-title"
                  aria-describedby="responsive-dialog-describe"
                >
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    <iframe
                      src={mapUrl}
                      width="100%"
                      height="450"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                    <div style={{ textAlign: "center" }}>
                      <Button
                        size="small"
                        style={{
                          background: "#000",
                          color: "#FFF",
                          width: "50%",
                          marginTop: "10px",
                        }}
                        onClick={closeOpen}
                        autoFocus
                      >
                        Fechar
                      </Button>
                    </div>
                  </div>
                </Dialog>
              </div>
            </div>
          }
        />
      </Container>
    </>
  );
}
export default NewPanel;
